import React, { useEffect, useState } from "react";
import { Button, Show, useShowController } from "react-admin";
import SessionExamGeneralInfo from "./SessionExamGeneralInfo/SessionExamGeneralInfo";
import SessionExamSlots from "./SessionExamSlotsInfo/SessionExamSlots";
import BackButtonToolbar from "features/BackButtonToolbar";
import { Dialog, DialogActions, DialogContent, Typography } from "@mui/material";
import SessionExamStudentInfo from "./SessionExamStudentInfo/SessionExamStudentInfo.js";
import SessionExamProfessorsInfo from "./SessionExamProfessorsInfo/SessionExamProfessorsInfo";
import ModalTitle, { withModalSx, modalButtonSx } from "server/components/Modals/ModalTitle";
import { settings } from "app";

const ShowSessionExam = () => {
  const { record } = useShowController();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (record && record.isSessionFinalized) {
      setOpen(true);
    }
  }, [record]);

  return (
    <Show
      title="Детайли за сесиен изпит"
      actions={<BackButtonToolbar />}
    >
      {record?.isSessionFinalized && (
        <Typography
          border="1px solid darkRed"
          borderRadius={5}
          color="darkRed"
          fontWeight={"bold"}
          fontSize={18}
          paddingY={1}
          paddingX={2}
          width="200px"
          textAlign="center"
          sx={{ marginLeft: "auto", mt: 4, mr: 8 }}
        >
          Финализирана
        </Typography>
      )}
      {record?.isSessionFinalized && (
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          sx={withModalSx()}
        >
          <ModalTitle
            title="Сесията е финализирана"
            color="error"
            // Old look: a big centered red title, no bar.
            legacySx={{ bgcolor: "transparent", color: "error.main", typography: "h4", textAlign: "center" }}
          />
          <DialogContent
            dividers={settings.style.modernUi}
            sx={settings.style.modernUi ? { p: 4 } : { px: 6, my: 1 }}
          >
            <Typography>
              Периодът на сесията, към който принадлежи този изпит, е финализиран. Моля, имайте предвид това при
              прегледа или редактирането на данните.
            </Typography>
          </DialogContent>
          <DialogActions sx={{ px: 2, pt: 2, borderTop: "1px solid #f0f0f0" }}>
            <Button
              onClick={() => setOpen(false)}
              variant="contained"
              color="error"
              size="medium"
              label="OK"
              sx={modalButtonSx}
            />
          </DialogActions>
        </Dialog>
      )}
      <SessionExamGeneralInfo />
      <SessionExamStudentInfo record={record} />
      <SessionExamProfessorsInfo record={record} />
      <SessionExamSlots record={record} />
    </Show>
  );
};

export default ShowSessionExam;
